class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', (e) => {
      if (typeof onKeyUpEscape === 'function') {
        onKeyUpEscape(e);
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    const elements = document.querySelectorAll('.js-facet-remove');
    if (elements) {
      elements.forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const params = new URLSearchParams(searchParams || '');
    
    if (!params.has('filter.p.tag')) {
      params.set('filter.p.tag', 'Deslogado');
    }
    
    const finalParams = params.toString();
    FacetFiltersForm.searchParamsPrev = finalParams;
    
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    
    if (loadingSpinners) {
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    }
    
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) collection.classList.add('loading');
    }
    
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${finalParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(finalParams);
  }

  createSearchParams(form) {
    if (!form) return 'filter.p.tag=Deslogado';
    
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    
    if (!searchParams.has('filter.p.tag')) {
      searchParams.set('filter.p.tag', 'Deslogado');
    }
    
    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (!event) return;
    
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    if (event.target && event.target.classList.contains('mobile-facets__checkbox')) {
      const form = event.target.closest('form');
      if (form) {
        const searchParams = this.createSearchParams(form);
        this.onSubmitForm(searchParams, event);
      }
    } else {
      const forms = [];
      const targetForm = event.target.closest('form');
      const isMobile = targetForm && targetForm.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!form) return;
        
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      
      if (forms.length > 0) {
        this.onSubmitForm(forms.join('&'), event);
      }
    }
  }

  onActiveFilterClick(event) {
    if (!event) return;
    
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    
    const url = event.currentTarget.href;
    const queryString = url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?') + 1);
    
    FacetFiltersForm.renderPage(queryString);
  }
  
  static getSections() {
    const productGrid = document.getElementById('product-grid');
    return productGrid && productGrid.dataset ? [{ section: productGrid.dataset.id }] : [];
  }
  
  static updateURLHash(searchParams) {
    if (searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? '?'.concat(searchParams) : ''}`);
    }
  }
  
  static renderSectionFromFetch(url, event) {
    if (!url) return;
    
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((error) => {
        console.error('Error fetching filtered products:', error);
      });
  }
  
  static renderSectionFromCache(filterDataUrl, event) {
    const cacheItem = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cacheItem) return;
    
    FacetFiltersForm.renderFilters(cacheItem.html, event);
    FacetFiltersForm.renderProductGridContainer(cacheItem.html);
    FacetFiltersForm.renderProductCount(cacheItem.html);
  }
  
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const previousElement = facetsToRender[index - 1];
          if (elementToRender.className === previousElement.className) {
            document.getElementById(previousElement.id)?.after(elementToRender);
            return;
          }
        }
        document.querySelector(`#${elementToRender.parentElement?.id} .js-filter`)?.before(elementToRender);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event) {
      const closestJSFilter = event.target.closest('.js-filter');
      if (closestJSFilter) {
        FacetFiltersForm.renderCounts(countsToRender, closestJSFilter);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilter.id));

        const newFacetDetailsElement = document.getElementById(closestJSFilter.id);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? '.mobile-facets__close-button'
            : '.facets__summary';
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
          const isTextInput = event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) targetElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      if (!sourceElement) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) targetElement.innerHTML = sourceElement.innerHTML;
    });

    const facetFormMobile = document.getElementById('FacetFiltersFormMobile');
    if (facetFormMobile) {
      const menuDrawer = facetFormMobile.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    if (!source || !target) return;

    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceContainer = parsedHTML.getElementById('ProductGridContainer');
    if (sourceContainer) {
      container.innerHTML = sourceContainer.innerHTML;

      container.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHTML.getElementById('ProductCount');
    
    if (sourceCount) {
      const count = sourceCount.innerHTML;
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      
      if (container) {
        container.innerHTML = count;
        container.classList.remove('loading');
      }
      
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    if (loadingSpinners) {
      loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.setListeners();
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');
    if (this.inputs) {
      this.inputs.forEach((element) => {
        element.addEventListener('change', this.onRangeChange.bind(this));
        element.addEventListener('keydown', this.onKeyDown.bind(this));
      });
    }
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    if (!event.currentTarget) return;
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    if (!this.inputs || this.inputs.length < 2) return;
    
    const minInput = this.inputs[0];
    const maxInput = this.inputs[1];
    
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', '0');
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max') || '');
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min') || 0);
    const max = Number(input.getAttribute('data-max')) || Infinity;

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (facetLink) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }

  closeFilter(event) {
    if (!event) return;
    
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') {
      form.onActiveFilterClick(event);
    }
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}

if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}